/* egnwtyliff 1.1.0 — run the existing warranty wizard inside LINE.
 *
 * Loaded by sections/warranty-supabase.liquid after the wizard's own script, and only
 * when the section's LIFF settings are filled in. Outside LINE nothing here engages and
 * the page behaves exactly as it does in a normal browser.
 *
 * It does not re-implement the form. It fills the name from the LINE profile and swaps
 * the wizard's transport (window.EGN_WTY_SEND), so validation, the done() summary and
 * the error strings all stay in one place.
 *
 * No scanCodeV2: the serial stickers are text only, and scanCodeV2 reads barcodes and QR
 * codes, not free text. The camera button keeps the wizard's own BarcodeDetector →
 * Tesseract path, which is what actually reads these stickers.
 */
(function () {
  'use strict';

  var cfg = window.EGN_LIFF || {};
  if (!cfg.liffId || !cfg.registerUrl || !window.liff) return;
  if (!document.getElementById('wtySteps')) return;

  var form = document.getElementById('egnWty2');
  if (form && form.tagName !== 'FORM') form = form.querySelector('form');
  if (!form) form = document.querySelector('.egn-wty2 form');
  if (!form) return;

  var idToken = null;

  // What matters is having a verified LINE identity, not being rendered inside the LINE
  // app. Inside LINE we can log the user in; in an ordinary browser we use the session
  // only if one already exists — sending every visitor to /pages/warranty off to LINE
  // Login would wreck the plain web form.
  function mark(v) { document.documentElement.setAttribute('data-egn-liff', v); }

  liff.init({ liffId: cfg.liffId }).then(function () {
    var inClient = liff.isInClient();
    if (!liff.isLoggedIn()) {
      if (!inClient) { mark('external-anonymous'); return; }
      liff.login();
      return;
    }
    mark(inClient ? 'in-client' : 'external-logged-in');
    idToken = liff.getIDToken();
    if (!idToken) { mark('no-id-token'); return; }   // needs the openid scope
    return liff.getProfile().then(prefill).then(installTransport);
  }).catch(function (e) {
    mark('error');
    if (window.console) console.warn('[egnwtyliff]', e && e.message);
  });

  /* displayName is one string and often a nickname, so offer it and leave every field
     editable — the imported history is full of odd name entries and a prefill should
     not quietly make that worse. */
  function prefill(p) {
    var parts = String(p.displayName || '').trim().split(/\s+/);
    fill(form.first_name, parts[0] || '');
    fill(form.last_name, parts.slice(1).join(' '));
    var t = liff.getDecodedIDToken && liff.getDecodedIDToken();
    if (t && t.email) fill(form.email, t.email);
  }

  function fill(el, v) { if (el && !el.value && v) el.value = v; }

  /* The wizard's error line only ever says "couldn't save". Append what actually came
     back so a failure can be read off the phone without attaching a debugger. */
  function showDetail(status, body) {
    var el = document.getElementById('egnWty2Err');
    if (!el) return;
    var reason = body;
    try {
      var j = JSON.parse(body);
      reason = [j.error, j.line_status, j.line, j.code].filter(Boolean).join(' · ');
    } catch (e) {}
    setTimeout(function () {
      el.textContent = (el.textContent || '') + ' [' + status + ' ' + String(reason).slice(0, 180) + ']';
      el.hidden = false;
    }, 0);
  }

  function installTransport() {
    window.EGN_WTY_SEND = function (f, file, locale, ok, fail) {
      var fd = new FormData();
      fd.append('id_token', idToken);
      ['first_name', 'last_name', 'email', 'phone', 'gender', 'birth_date', 'address',
       'purchase_date', 'product_type', 'model', 'serial', 'purchase_channel', 'order_no'].forEach(function (k) {
        if (f[k]) fd.append(k, f[k].value || '');
      });
      fd.append('consent_marketing', f.consent && f.consent.checked ? '1' : '0');
      fd.append('locale', locale);
      if (file) fd.append('slip', file);

      fetch(cfg.registerUrl, { method: 'POST', body: fd })
        .then(function (r) {
          return r.text().then(function (body) {
            if (!r.ok) {
              // the form can only show its own generic message, so put the real reason
              // somewhere a phone can reach: the console and an attribute on <html>
              if (window.console) console.error('[egnwtyliff] ' + r.status + ' ' + body);
              document.documentElement.setAttribute(
                'data-egn-liff-error', r.status + ' ' + body.slice(0, 200)
              );
              // put it on screen too — reading an attribute on a phone needs a debugger
              showDetail(r.status, body);
              throw new Error('save');
            }
            ok();
          });
        })
        .catch(function (e) {
          if (window.console) console.error('[egnwtyliff]', e && e.message);
          fail('save');
        });
    };
  }
})();
